type Coverage = 'proxy' | 'partial' | 'full';

interface Props {
  /** Whether the figure is connected to live data or a modeled estimate. */
  kind?: 'estimate' | 'connected';
  /** How complete the underlying data is. */
  coverage?: Coverage;
  /** Optional one-phrase basis, e.g. "modeled on a representative cost stack". */
  basis?: string;
}

// Every figure carries its provenance on the figure (spec 11.4 Rule 4): connected vs estimate and
// how complete the data is. No bare number on any screen. For the seeded demo, the dollar figures
// are honest modeled estimates on partial coverage — never shown as calibrated.
export default function ProvenanceChip({ kind = 'estimate', coverage = 'partial', basis }: Props) {
  const lead = kind === 'connected' ? 'Connected' : 'Estimate';
  const parts = basis ? [lead, basis, `${coverage} coverage`] : [lead, `${coverage} coverage`];
  return (
    <span className="prov-chip" title="How this figure was produced">
      {parts.join(' · ')}
    </span>
  );
}
